import { states } from "../constants/requirements";
import { isPropNotEmpty } from "../object";

const addSSElectiveRequirementsStatus = (requirements = []) =>
  requirements.map((requirement) => {
    const { status } = requirement;
    let reqStatus = status;

    if (isPropNotEmpty(requirement, "leaderApprovedDate")) {
      reqStatus = states.approved;
    } else if (isPropNotEmpty(requirement, "dateCompleted")) {
      reqStatus = states.submit;
    }
    return {
      ...requirement,
      status: reqStatus,
    };
  });

export default addSSElectiveRequirementsStatus;
